import { Button } from "@ebscois/react-component-library";
import styled from "styled-components";

export const StyledCmeButton = styled(Button)`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.quaternary.base};
  border-radius: calc(${({ theme }) => theme.border.radius.xl} * 2);
  color: ${({ theme }) => theme.colors.white};
  min-height: ${({ theme }) => theme.space.lg};
  padding: calc(${({ theme }) => theme.space.sm} / 2)
    calc(${({ theme }) => theme.space.sm} * 1.5);
  line-height: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-top: ${({ theme }) => theme.space.sm};
    padding-bottom: ${({ theme }) => theme.space.sm};
    min-width: calc(${({ theme }) => theme.space.lg} * 2);
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
